$(document).ready(function () {
  let isAmountAdjust = false;
  window.veriff = { result: null }
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  $(".appoinment_icon_wrapp .appoinment_contant_wrapp.without_homepage_header a").click(function () {
    setCookie("appointmentform", "appointmentform", 1);
  });
  $(".main_claculator-right-part .right-side-bottom a.btn").click(function () {
    setCookie("appointmentform", "appointmentform", 1);
  });
$(".custom-first-menu-here").click(function() {
   $(this).parents("li.slide-nav__item").toggleClass("active-menu") 
});
  
  jQuery.getJSON("/cart.js", function (cart) {
    var original_price = cart.total_price,
      total_goal = $(".sidebar_progress_bar").attr("data-goal"),
      final_result = original_price / 100
    if (final_result >= total_goal) {
      $("span.minus_val").hide();
      $(".free_shipping_text").show();
    } else if (final_result < total_goal) {
      $(".free_shipping_text").hide();
    }
  });
  $("ul.site-nav li.site-nav--has-dropdown").mouseleave(function () {
    $("body").removeClass("on_header_hover");
  });
  $("ul.site-nav li.site-nav--has-dropdown").mouseenter(function () {
    $("body").addClass("on_header_hover");
  });

  $(document).on("change", "input[type=date]", function () {
    var data_value_get = $(this).val();
    if (data_value_get !== "") {
      $(this).removeClass("placeholder_shown");
      $(this).addClass("placeholder_hide");
    } else {
      $(this).addClass("placeholder_shown");
      $(this).removeClass("placeholder_hide");
    }
  });

  $(document).on("focus", "input[type=date]", function () {
    var data_value_get = $(this).val();
    if (data_value_get !== "") {
      $(this).removeClass("placeholder_shown");
      $(this).addClass("placeholder_hide");
    } else {
      $(this).addClass("placeholder_shown");
      $(this).removeClass("placeholder_hide");
    }
  });

  $('#datepic_client_date, #second_datepic_client_date').click(function(e){
     e.preventDefault();
    var moment = new Date();
  }).datepicker({
    minDate: new Date(),
    dateFormat: "yy-mm-dd",
    beforeShowDay: function (date) {
      return date.getDay() == 1 || date.getDay() == 0 ? [false, " disabled"] : [true, " enabled"];
    }
  });
});
function addJsScript(src) {
  var script = document.createElement("script");
  script.src = src;
  document.head.appendChild(script);
}
let thisElement = null;
let isAmountAdjusting = false;
// addJsScript("https://cdn.veriff.me/sdk/js/1.5/veriff.min.js")
// addJsScript("https://cdn.veriff.me/incontext/js/v1/veriff.js")
let isLoadingAdjuster = false
let isFistTimePageLoad = true;
$(document).ready(function () {
  adjustAmount(true);
  $(document).on("CartDrawer:open drawerOpen ajaxProduct:added", () => {
    adjustAmount(false);
  });
  $(document).on("cart:updated", () => {
    console.log("cart:updated")
    adjustAmount(false);
    if(!isFistTimePageLoad){
      setTimeout( () => { window.location.reload() },500)
    }
  });
  $(".adjust-value").on("keyup", function (e) {
    isAmountAdjusting = true;
  })
  $(".adjust-value").on("change", function (e) {
    isLoadingAdjuster = true
    let newVal = parseFloat($(this).val().replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1"));
    let symbol = "-";
    let itemAmount = parseFloat($(this).data("value"));
    if (newVal > itemAmount) {
      symbol = "+";
    }
    let remainAmount = Math.abs(itemAmount - newVal);
    thisElement = {
      symbol: symbol,
      remainAmount: remainAmount,
      id: $(this).data("id"),
      qty: $(this).parents(".cart__item").find(".js-qty__num").val(),
    };
    $(this).attr("data-adjust_symbol", symbol);
    $(this).attr("data-adjust_amount", remainAmount);
    adjustAmount(false);
  });
   $(document).on("click", "#myBtn", async function (e) {
    await updateCartItem();
    initViriffCheckout();
  });
  $(document).on("click", "#myModalClose", function (e) {
    $("#myModal").hide();
  });
  $(document).on("click", function (e) {
    if (!$(e.target).hasClass("adjust-value")) {
      updateCartItem();
    }
  });
});
async function updateCartItem() {
  if (thisElement != null) {
    let id = thisElement.id;
    let amount = thisElement.remainAmount;
    let symbol = thisElement.symbol;
    let qty = thisElement.qty;

    let updates = {
      id: "" + id,
      quantity: qty,
      properties: { _adjust_amount: amount, _adjust_symbol: symbol },
    };

    try {
      const response = await fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updates),
      });

      const result = await response.json();

      isAmountAdjusting = false;
      thisElement = null;
      isLoadingAdjuster = false;
      adjustAmount(false);
    } catch (error) {
      console.error("Error:", error);
    }
  }
}
function initViriffCheckout() {
  let oldBtnText = $("#myBtn").html()
  $("#myBtn").attr("disabled", "true").html('Veuillez patienter...')
  if(isAmountAdjusting){
    setTimeout(()=>{
      initViriffCheckout()
    },500)
    return false;
  }
  // proceedVeriff();
  // $(".veriff-description").html("Toute transaction liée aux métaux précieux est obligatoirement nominative : présentation et enregistrement d'une pièce d'identité (passeport, carte d'identité, permis de conduire, permis de séjour)");
  // $("p.veriff-description").insertBefore("input#veriff-submit-btn");
  if(ShopifyAnalytics.meta.page.customerId && (isAmountAdjust || $(".shipping-line-item--radio input[type='radio']:checked").val() == "In branch pick-up")){
    $.getJSON("/cart.js", function (data) {
      $.post("https://goldunion.codevibez.com/veriff/index.php", {
        shop: "goldunion-uk.myshopify.com",
        customer: ShopifyAnalytics.meta.page.customerId ?? "",
        cart: data,
        email: $("#client-email").val(),
        shipping: {
          name: $(".shipping-line-item--radio input[type='radio']").length > 0 ? $(".shipping-line-item--radio input[type='radio']:checked").val() : "",
          agent: $("#agency-id").length > 0 ? $("#agency-id").val() : "",
        },
      },
        (result) => {
          window.location = result.order.invoice_url;
        }
      );
    });
  }else{
    window.location = window.location.origin + "/checkout"
  }
}
// function proceedVeriff() {
//   $("#myModal").show();
//   const veriff = Veriff({
//     host: "https://stationapi.veriff.com",
//     apiKey: "edd24ee3-79d3-40cb-835a-60091d3ad3ee",
//     parentId: "veriff-root",
//     onSession: (err, response) => {
//       window.veriffSDK.createVeriffFrame({
//         lang: "fr",
//         url: response.verification.url,
//         onEvent: (msg) => {
//           if (msg == "FINISHED") {
//             if (window.veriff.result == null) {
//               window.location = window.location.origin + "/checkout"
//             } else {
//               window.location = window.veriff.result.order.invoice_url;
//             }
//           }
//         },
//       });
//     },
//   });
//   veriff.mount({
//     formLabel: {
//       givenName: "Prénom",
//       lastName: "Nom",
//       vendorData: "Numéro de téléphone",
//     },
//     submitBtnText: "Commencer la vérification",
//     loadingText: "S'il vous plaît, attendez...",
//   });
// }
function adjustAmount(updateValue) {
  let addedAmount = 0;
  isAmountAdjust = false;
  if ($(".adjust-value").length > 0) {
    isFistTimePageLoad = false;
    $(".adjust-value").each(function () {
      let symbol = $(this).attr("data-adjust_symbol");
      let amount = parseFloat($(this).attr("data-adjust_amount"));
      let itemAmount = parseFloat($(this).attr("data-value"));
      let amt = 0;
      if (amount > 0) {
        isAmountAdjust = true;
      }
      let qty = parseInt(
        $(this).parents(".cart__item").find(".js-qty__num").val()
      );
      if (symbol == "+") {
        amt += amount;
        itemAmount += amount;
      } else {
        amt -= amount;
        itemAmount -= amount;
      }

      addedAmount += amt * qty;
      if ($(".cart__drawer-form").length > 0) {
        $(this)
          .parents(".cart__item")
          .find(".pricediv")
          .html(theme.Currency.formatMoney(itemAmount * 100));
      }
      if (updateValue) $(this).val(itemAmount);
    });
    $("#main--shipping-div").hide();
    if(isAmountAdjust){
      $("#main--shipping-div").show();
    }
    let cartTotalItem = $(".main__cart__item-sub--subtotal");
    let total = theme.Currency.formatMoney(
      parseInt(cartTotalItem.data("total")) + addedAmount * 100
    );
    $(".main__cart__item-sub--subtotal-adjust").remove();
    $(".cart__item--subtotal--adjust").append(
      '<div class="main__cart__item-sub--subtotal-adjust"></div>'
    );
    $(".main__cart__item-sub--subtotal--adjust").hide();
    if ($(".main__cart__item-sub--subtotal-adjust").length > 0) {
      $(".main__cart__item-sub--subtotal-adjust").html(total);
      return;
    }
    if ($(".cart__drawer-form").length > 0) {
      $(
        ".cart__drawer-form .main__cart__item-sub--subtotal .wholesale-cart-total span"
      ).html(total);
      return;
    }
  }
}
function validatePhoneNumber(input_str) {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

    return re.test(input_str);
}

function sendContactFormAction(formSelector) {

   var phone = $(formSelector).find(".custom_mobile_fileds").val();
   var dateofbith = $(formSelector).find(".hasDatepicker").val();
var meeting_time = $("select[name=client_time]").val();
    if (!validatePhoneNumber(phone) || dateofbith == '' || meeting_time == 'Heure') {
       if (!validatePhoneNumber(phone)) {
     $(formSelector).find(".contact-error-message").show();
      $(formSelector).find(".mobile_label_input").addClass("mobile-error-show");
                  $(formSelector).find(".date-error-message").hide();
      $(formSelector).find(".date_main-wrapp").removeClass("mobile-error-show");
                    $(formSelector).find(".time-error-message").hide();
      $(formSelector).find(".time_main-wrapp").removeClass("mobile-error-show");
       }else if(dateofbith == ''){
         $(formSelector).find(".date-error-message").show();
      $(formSelector).find(".date_main-wrapp").addClass("mobile-error-show");
          $(formSelector).find(".contact-error-message").hide();
      $(formSelector).find(".mobile_label_input").removeClass("mobile-error-show");
                             $(formSelector).find(".time-error-message").hide();
      $(formSelector).find(".time_main-wrapp").removeClass("mobile-error-show");
      }else if(meeting_time == 'Heure'){
         $(formSelector).find(".date-error-message").hide();
      $(formSelector).find(".date_main-wrapp").removeClass("mobile-error-show");
          $(formSelector).find(".contact-error-message").hide();
      $(formSelector).find(".mobile_label_input").removeClass("mobile-error-show");
           $(formSelector).find(".time-error-message").show();
      $(formSelector).find(".time_main-wrapp").addClass("mobile-error-show");
      }
    }else{
 $(formSelector).find(".contact-error-message").hide();
      $(formSelector).find(".mobile_label_input").removeClass("mobile-error-show");
        $(formSelector).find(".date-error-message").hide();
      $(formSelector).find(".date_main-wrapp").removeClass("mobile-error-show");
       $(formSelector).find(".time-error-message").hide();
      $(formSelector).find(".time_main-wrapp").removeClass("mobile-error-show");
      $(".brn-contact-form-submit").attr("disabled", "true").html("Rendez-vous confirmé ...");
  let formAction = "https://goldunion.codevibez.com/api/contact";
  let formEl = document.querySelector(formSelector);
  var formData = new FormData(formEl);
  var object = {
    "shop": "goldunion-uk.myshopify.com",
    "country_code": $(formSelector+" .iti__selected-dial-code").html()
  };
  formData.forEach((value, key) => (object[key] = value));
  var json = JSON.stringify(object);
  fetch(formAction, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: json,
  })
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      $(".brn-contact-form-submit").removeAttr("disabled", "true").html("Confirmer mon rendez-vous");
      $(".note--success").html(result.message).show();
              var data_handle = $(formSelector).parents(".tab_data_main").attr("data-handle");
if(data_handle == 'En agence'){
    var agency_name = $(formSelector).find("select#agency-id option:selected").val();
}else{
  var agency_name = $(formSelector).find("input#search_input").val();
}
var data_currency = $("html").attr("currency");
      gtag('event', 'conversion', {
    'send_to': 'G-MTHYR484J8',
    'Home or Agency': data_handle,
    'Agency name (city)': agency_name,
    'currency': data_currency
    });
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  return false;


    }

}

var searchInput = "search_input";

$(document).ready(function () {
  var autocomplete;
  autocomplete = new google.maps.places.Autocomplete(
    document.getElementById(searchInput),
    {
      types: ["geocode"],
componentRestrictions: { country: "uk" }
    }
  );

  google.maps.event.addListener(autocomplete, "place_changed", function () {
    var near_place = autocomplete.getPlace();
    if (document.getElementById("loc_lat"))
      document.getElementById("loc_lat").value =
        near_place.geometry.location.lat();
    if (document.getElementById("loc_long"))
      document.getElementById("loc_long").value =
        near_place.geometry.location.lng();

    if (document.getElementById("latitude_view"))
      document.getElementById("latitude_view").innerHTML =
        near_place.geometry.location.lat();
    if (document.getElementById("longitude_view"))
      document.getElementById("longitude_view").innerHTML =
        near_place.geometry.location.lng();
  });
});

$(document).on("change", "#" + searchInput, function () {
  if (document.getElementById("latitude_input"))
    document.getElementById("latitude_input").value = "";
  if (document.getElementById("longitude_input"))
    document.getElementById("longitude_input").value = "";

  if (document.getElementById("latitude_view"))
    document.getElementById("latitude_view").innerHTML = "";
  if (document.getElementById("longitude_view"))
    document.getElementById("longitude_view").innerHTML = "";
});
$(document).on(
  "change",
  ".shipping-line-item--radio input[type='radio']",
  function () {
    $(".agent-dropdown").hide();
    if ($(this).data("agent") == true) {
      $(this)
        .parents(".shipping-line-item--radio")
        .find(".agent-dropdown")
        .show();
    }
  }
);
$(document).on("click",".accordion-section-wrapper-main .custom_accordion-btn",function() {
    $(this).parents(".accordion-section-wrapper-main").find(".accordion-section-content_last").slideToggle();
});